module.exports = __webpack_public_path__ + "img/receipt-xishuangbanna-invoice-stamp-crisp.a3b67d78.png";